import { Box, Button, Flex, Text, Tooltip } from "@chakra-ui/react";
import IconBox from "components/icons/IconBox";
import { IconCardDiscover, IconCardExpress, IconCardMaster, IconCardVisa } from "components/icons/Icons";

const getCardBrandLabel = (brand?: string) => {
  const b = String(brand || "").toLowerCase();
  if (b === "visa") return "Visa";
  if (b === "mastercard") return "Mastercard";
  if (b === "americanexpress" || b === "amex") return "American Express";
  if (b === "discover") return "Discover";
  return "Card";
};

export default function SavedCardsList(props: {
  cards: any[];
  selectedCard: any;
  onSelectCard: (card: any) => void;
  onRemoveCard: (cardId: number) => void;
}) {
  const { cards, selectedCard, onSelectCard, onRemoveCard } = props;

  return (
    <Box>
      {cards.map((card: any, index: number) => (
        <Flex
          key={index}
          padding="10px 14px"
          alignItems="center"
          border={`1px solid ${selectedCard?.pm_id === card?.pm_id ? "#2F80ED" : "#E5E7EB"}`}
          borderRadius="12px"
          mb={index === cards.length - 1 ? "0px" : "12px"}
          bg={selectedCard?.pm_id === card?.pm_id ? "#F3F8FF" : "white"}
          cursor="pointer"
          onClick={() => {
            onSelectCard(card);
          }}
        >
          <Tooltip label={getCardBrandLabel(card?.card_brand)} placement="top" hasArrow>
            <IconBox
              mr="12px"
              w="40px"
              h="25px"
              icon={
                card?.card_brand === "visa" ? (
                  <IconCardVisa w="40px" h="25px" />
                ) : card?.card_brand === "mastercard" ? (
                  <IconCardMaster w="40px" h="25px" />
                ) : card?.card_brand === "americanexpress" || card?.card_brand === "amex" ? (
                  <IconCardExpress w="40px" h="25px" />
                ) : card?.card_brand === "discover" ? (
                  <IconCardDiscover w="40px" h="25px" />
                ) : (
                  ""
                )
              }
            />
          </Tooltip>
          <Box flex="1">
            <Text fontSize="16px" lineHeight="22px" fontWeight="400" color="#111827">
              ending in {card?.card_number?.slice(-4)}
            </Text>
          </Box>
          <Button
            variant="link"
            fontSize="14px"
            fontWeight="600"
            color="#3A7BFF"
            _hover={{ textDecoration: "underline" }}
            onClick={(e) => {
              e.stopPropagation();
              onRemoveCard(card.id);
            }}
          >
            Delete
          </Button>
        </Flex>
      ))}
    </Box>
  );
}
